"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconGoal from "@/app/(components)/generics/Icons/IconGoal";
import IconPlus from "@/app/(components)/generics/Icons/IconPlus";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { emptyObjectiveExamples } from "./ObjectiveEmpty.logic";
import styles from "./ObjectiveEmpty.module.css";

type Props = {
  onCreate?: (label?: string) => void;
};

export default function ObjectiveEmpty(props: Props) {
  const T = useT();
  const { onCreate } = props;

  const examples = emptyObjectiveExamples(T);

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <IconGoal />
      </div>

      <div className={styles.content}>
        <h2 className={styles.title}>{T(TKey.MESSAGES_CONTENT_OBJECTIVE_EMPTY_TITLE)}</h2>
        <p className={styles.description}>
          {T(
            onCreate
              ? TKey.MESSAGES_CONTENT_OBJECTIVE_EMPTY_TEXT
              : TKey.MESSAGES_CONTENT_OBJECTIVE_EMPTY_READER,
          )}
        </p>

        {onCreate && (
          <>
            <span className={styles.examplesLabel}>
              {T(TKey.MESSAGES_CONTENT_OBJECTIVE_EMPTY_EXAMPLES)}
            </span>
            <div className={styles.examples}>
              {examples.map((example) => (
                <Button
                  key={example}
                  text={example}
                  type={ButtonType.MUTED}
                  isLink={false}
                  min={true}
                  onClick={() => onCreate(example)}
                />
              ))}
            </div>

            <div className={styles.actions}>
              <Button
                text={T(TKey.MESSAGES_CONTENT_OBJECTIVE_ADD) as string}
                type={ButtonType.PRIMARY}
                isLink={false}
                beforeIcon={<IconPlus />}
                onClick={() => onCreate()}
                min={true}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
